import React, { useEffect, useState } from "react";

// Material UI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from '@mui/material/Tooltip';

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";

// Icons
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from '@mui/icons-material/Block';

// Components
import Input from "../inputs/input";
import BranchStockDropdown from "../branchStockDropdown";
import SwiperImg from "../swiper";

// Hooks
import useUser from "../../hooks/user/useUser";

// Style
import useStyles from "./styles";
import { utils } from "../../utils/utils";

const Item = ({
  shoppingMode,
  product,
  onAdd,
  onRemove,
  onView,
  colorSelected = "",
  refId = ""
}) => {
  const { classes } = useStyles();
  const [variantSelected, setVariantSelected] = useState({});
  const [quantity, setQuantity] = useState(1);
  const [stocks, setStocks] = useState([]);
  const [stock, setStock] = useState({});
  const [price, setPrice] = useState({});
  const [title, setTitle] = useState(product.name);
  const { branch } = useUser();
  const [warehouseId, setWarehouseId] = useState(branch.warehouseId);
  const [colorSelect, setColorSelect] = useState();
  const [productSelected, setProductSelected] = useState({});

  useEffect(() => {
    if (variantSelected) {
      if (variantSelected.stock) {
        const stockCollection = variantSelected.stock;
        const currentStock = stockCollection.find(
          (c) => c.warehouseId === warehouseId
        );
        // TODO: Si no existe variante del branch, buscar por cercania
        setStocks(stockCollection);
        setStock(currentStock || stockCollection[0]);
        setColorSelect(variantSelected?.color?.name)
      }

      setTitle(variantSelected.name ? variantSelected.name : product.name);
      setProductSelected(product);
    }
  }, [branch, variantSelected, product, warehouseId]);

  useEffect(() => {
    if (variantSelected?.prices) {
      const currentPrice = variantSelected.prices.find(
        (c) => c.priceListId === branch.priceListId
      );
      setPrice(currentPrice);
    }
  }, [branch.priceListId, variantSelected]);

  useEffect(() => {
    setQuantity(1);
  }, [stock]);

  useEffect(() => {
      let index = product.variants.findIndex(p =>
          p?.stock?.some(s =>
              s.warehouseId === branch.warehouseId && s.quantity > 0
          )
      );

      if (index < 0) {
          index = 0;
      }

      const selectedCode =
          product.variants.find(p =>
              (p.color.code.toLowerCase() === colorSelected?.toLowerCase() || p.refId === refId) &&
              p?.stock?.some(s => s.warehouseId === branch.warehouseId && s.quantity > 0)
          ) ?? product.variants[index];

      setVariantSelected(selectedCode);
  }, [product, colorSelected, refId]);

  const hasPromotion = () =>
    product.variants &&
    product.variants.some(
      (variant) => variant.promotions && variant.promotions.length > 0
    );

  const handleChangeWarehouse = (event) => {
    setStock(event.target.value);
    setWarehouseId(event.target.value.warehouseId);
  };

  const handleInputChange = (event) => {
    const num = Number.parseInt(event.target.value);
    if (!isNaN(num)) setQuantity(num);
  };
  
  let labelNA = " "

  const colorWithStock = ( colors) => {
    if (colors.primaryColorHexa === null || colors.primaryColorHexa === "" ) {
      labelNA = "N/A"
      return "grey" 
}

      if (!!colors.primaryColorHexa && colors.secundaryColorHexa === null)
        return colors.primaryColorHexa
        
      if(!!colors.primaryColorHexa && !!colors.secundaryColorHexa)
      return `linear-gradient(to right, ${colors.primaryColorHexa} 0%, ${colors.primaryColorHexa} 50%, ${colors.secundaryColorHexa}  50%, ${colors.secundaryColorHexa}  100% )`
    }

    const VariantChangeSelected = (product, variant) => {
      setVariantSelected(variant)
      setProductSelected(product);
    }
    
  return (
    <Box className={classes.root}>
      {hasPromotion() && (
        <Grid>
          {price?.promotionDisplay && (
          <Grid className={classes.arrow}>{price.promotionDisplay}</Grid>
       )}
        </Grid>
      )}
      <Card className={classes.card}>
        <div className={classes.cardActionArea}>
          
          <SwiperImg imagenes={variantSelected?.medias} />
          

          <CardContent className={classes.cardContent}>
            <Grid container spacing={1} style={{ marginBottom: 8 }}>
              <Grid size="grow">
                <Typography variant="subtitle1" component="h2">
                  {title}
                </Typography>
                <Typography variant="caption" display="block">
                  <strong>
                    {variantSelected?.refId?.lastIndexOf("%") >= 0
                      ? variantSelected?.refId?.substr(
                          0,
                          variantSelected?.refId?.lastIndexOf("%")
                        )
                      : variantSelected?.refId}{" "}
                  </strong>
                </Typography>
              </Grid>
              <Grid>
                <IconButton onClick={() => onView(productSelected, variantSelected)} size="large">
                  <VisibilityIcon />
                </IconButton>
              </Grid>
              <Grid container spacing={1} size={12}>
                {product.variants &&
                  product.variants.map((variant) => {
                    const branch = variant.stock.filter(
                      (s) => s.warehouseId === stock?.warehouseId
                    );
                    return (
                      <Tooltip title={variant.color.code} key={variant.refId}>
                        <Grid key={variant.color.code}>
                          {branch[0]?.quantity <= 0 && <BlockIcon className= {classes.iconBan} onClick={() => VariantChangeSelected(product, variant)} /> }         
                        <Chip
                            style={{background: colorWithStock(variant.color)}}
                            classes={{disabled: branch[0]?.quantity > 0 ? classes.customChipDisabledWhitStock : classes.customChipDisabled}}
                            label={branch[0]?.quantity > 0 ? null : labelNA}              
                            className={branch[0]?.quantity > 0 ? classes.whitStock : classes.whitOutStock}
                            size="small"
                            disabled={variant.refId === variantSelected.refId}
                            onClick={() => VariantChangeSelected(product, variant)}
                        /> 
                        </Grid>
                      </Tooltip>
                    );
                  })}
              </Grid>
                  <Box item xs={12} my={2}>
                    <Typography>Color: {colorSelect}</Typography>
                    {variantSelected?.size?.description && (
                      <Typography>Talle: {variantSelected.size.description}</Typography>
                    )}
                  </Box>
            </Grid>
            <Grid container spacing={1}>
              <Grid size={5}>
                <Typography>
                  Stock: <strong>{stock?.quantity || 0}</strong>
                </Typography>
              </Grid>
              <Grid size={7}>
                <Typography
                  variant="subtitle1"
                  align="right"
                  className={price?.promotionPrice ? classes.oldPrice : ""}
                >
                  {price?.currency || "ARS"}{" "}
                  <strong>{utils.formatMoney(price?.price) || "0.00"}</strong>
                </Typography>
                {price?.promotionPrice && (
                  <Typography
                    variant="subtitle1"
                    align="right"
                    className={classes.newPrice}
                  >
                    {price?.currency || "ARS"}{" "}
                    <strong>{utils.formatMoney(price.promotionPrice)}</strong>
                  </Typography>
                )}
              </Grid>
            </Grid>
          </CardContent>
        </div>

        <CardActions>
          <Grid
            container
            spacing={1}
            justifyContent="center"
            alignContent="center"
          >
            <Grid size={12}>
              {!!stocks && !!stocks.length
? (
                <BranchStockDropdown
                  fullWidth
                  size="small"
                  label="Deposito"
                  getOptionLabel={(option) => (
                    <span>{option?.warehouseName}</span>
                  )}
                  getOptionValue={(option) => option}
                  onChange={handleChangeWarehouse}
                  value={stock}
                  values={stocks}
                />
              )
: (
                <Chip
                  className={classes.noStockChip}
                  color="primary"
                  label="Sin Stock"
                  variant="outlined"
                />
              )}
            </Grid>
            {shoppingMode && (
              <>
                <Grid>
                  <Button
                    size="large"
                    color="primary"
                    variant="outlined"
                    onClick={() =>
                      onRemove(
                        {
                          masterProductId: product.id,
                          productId: variantSelected.productId,
                          refId: variantSelected.refId,
                          quantity,
                          warehouseId: stock?.warehouseId || branch.warehouseId,
                        },
                        branch.priceListId
                      )
                    }
                  >
                    <DeleteIcon />
                  </Button>
                </Grid>
                <Grid size="grow">
                  <Input
                    fullWidth
                    size="small"
                    type="number"
                    label="Cantidad"
                    value={quantity}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid>
                  <Button
                    data-cy="add-product"
                    size="large"
                    color="primary"
                    variant="outlined"
                    onClick={() =>
                      onAdd(
                        {
                          masterProductId: product.id,
                          productId: variantSelected.productId,
                          refId: variantSelected.refId,
                          quantity,
                          warehouseId: stock?.warehouseId || branch.warehouseId,
                        },
                        branch.priceListId
                      )
                    }
                  >
                    <AddIcon />
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </CardActions>
      </Card>
    </Box>
  );
};
export default Item;
